import { render, staticRenderFns } from "./PostbackView.vue?vue&type=template&id=1b0a56ec&scoped=true"
import script from "./PostbackView.vue?vue&type=script&lang=js"
export * from "./PostbackView.vue?vue&type=script&lang=js"
import style0 from "./PostbackView.vue?vue&type=style&index=0&id=1b0a56ec&prod&lang=scss&scoped=true"
import style1 from "./PostbackView.vue?vue&type=style&index=1&id=1b0a56ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0a56ec",
  null
  
)

export default component.exports